import { Component, OnInit, ViewChild, AfterViewInit  } from '@angular/core'
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { CoreTranslationService } from '@core/services/translation.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CoreConfigService } from '@core/services/config.service';
import { ColumnMode, DatatableComponent, id } from '@swimlane/ngx-datatable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  public contentHeader: object
  public country = [
    {country: 'Egypt',id: '1'},
    {country: 'Saudi Arabia',id: '2'},
    {country: 'Qatar',id: '3'},
    {country: 'Oman',id: '4'}
  ]
  /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(private _coreTranslationService: CoreTranslationService,private modalService: NgbModal) {
    this._coreTranslationService.translate(en, fr, de, pt)
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  ngOnInit() {
    document.getElementById('الرئيسية')?.classList.remove('active')
    document.getElementById('الفعاليات')?.classList.remove('active')
    document.getElementById('المشرفين')?.classList.remove('active')
    document.getElementById('المستخدمين')?.classList.remove('active')
    document.getElementById('طلبات المشرفين')?.classList.remove('active')
    document.getElementById('فئات المناسبات')?.classList.remove('active')
    document.getElementById('العروض')?.classList.remove('active')
    document.getElementById('المسئولين')?.classList.remove('active')
    
    this.columns = [
      {
        prop: 'selected',
        name: '',
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50
      },
      { prop: '#' },
      { prop: 'عنوان الاشعار' },
      { prop: 'محتوى الاشعار' },
      { prop: 'البلد' },
      { prop: 'التوقيت' }
    ]
    this.rows = [
      {
        id: 1,
        "#":"1",
        'عنوان الاشعار': "عرض جديد",
        'محتوى الاشعار': "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص.",
        'البلد': "السعودية",
        'التوقيت': "sat 12/8/2024 8:32 PM"
      }
    ];
    this.temp = this.rows

    this.contentHeader = {
      headerTitle: 'الاشعارات',
      actionButton: false
    }
  }

  // table
  public readonly pageLimitOptions = [
    {value: 5},
    {value: 10},
    {value: 25},
    {value: 50},
    {value: 100},
  ];
  public chkBoxSelected = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  ColumnMode = ColumnMode;
  columns = []
  customChkboxOnSelect({ selected }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';
  
    // Filter data by checking all columns
    const temp = this.temp.filter((row) => {
      return Object.keys(row).some((key) => 
        row[key]?.toString().toLowerCase().includes(val)
      );
    });
  
    // Update the rows
    this.rows = temp;
    console.log(temp)
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }

  // modal
  modalOpenDefault(modalDefault) {
    this.modalService.open(modalDefault, {
      centered: true
    });
  }
  modalOpenLG(modalLG) {
    this.modalService.open(modalLG, {
      centered: true,
      size: 'lg'
    });
  }
  deletedItemId: any
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }

  
  // download files
  downloadFile(file: string){
    if(file == 'pdf'){
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير فئات الفعاليات</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0]).map(header => `<th>${header}</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows.map(row => `
                  <tr>
                    ${Object.keys(row).map(key => `<td>${row[key].toString().replace(/<[^>]*>/g, '')}</td>`).join("")}
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    }else if(file == 'excel'){
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }
    
      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility
    
      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]); 
      csvContent += headers.join(",") + "\n";
    
      // Add Table Rows
      this.rows.forEach(row => {
        const rowData = headers.map(header => {
          let cell = row[header] ? row[header].toString() : '';
          return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, '')}"`; // Escape quotes & remove HTML
        }).join(",");
        csvContent += rowData + "\n";
      });
    
      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "event_Categories.csv");
      document.body.appendChild(link);
    
      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }
}

